import { Redirect, Slot } from "expo-router";
import { useCallback, useRef } from "react";
import { ScrollView, StyleSheet } from "react-native";

import "@/global.css";

import { ThemedFooter } from "@/components/ThemedFooter";
import { useAccessToken } from "@/hooks/useAccessToken";
import {
  LayoutScrollProvider,
  type LayoutScrollToTopOptions,
} from "@/hooks/useLayoutScroll";
import { useSessionExpiryGuard } from "@/hooks/useSessionExpiryGuard";
import { StatusBannerProvider } from "@/hooks/useStatusBanner";

export default function AuthLayout() {
  const scrollViewRef = useRef<ScrollView | null>(null);
  useSessionExpiryGuard();
  const { token, isLoading } = useAccessToken();

  const scrollToTop = useCallback((options: LayoutScrollToTopOptions = {}) => {
    scrollViewRef.current?.scrollTo({
      x: 0,
      y: 0,
      animated: options.animated ?? true,
    });
  }, []);

  if (isLoading) {
    return null;
  }

  if (!token) {
    return <Redirect href="/" />;
  }

  return (
    <StatusBannerProvider>
      <LayoutScrollProvider scrollToTop={scrollToTop}>
        <ScrollView
          ref={scrollViewRef}
          style={styles.scrollView}
          contentContainerStyle={styles.contentContainer}
        >
          <Slot />
          <ThemedFooter />
        </ScrollView>
      </LayoutScrollProvider>
    </StatusBannerProvider>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
    backgroundColor: "#fff",
  },
  contentContainer: {
    backgroundColor: "#fff",
    flexDirection: "column",
    alignItems: "stretch",
    flexGrow: 1,
  },
});
